export const COUNT_STATIC_TABS = 1;

/**
 * Enum параметров поиска для всего приложения
 */
export const SEARCH_PARAMS = {
  share: 'share',
  editProductId: 'editProductId',
  tab: "tab"
};
